import clsx from 'clsx'

import cl from './Pagination.module.scss'

const shouldRenderInnerSpan = (index: number, activeIndex: number) => index === activeIndex

interface PaginationProps {
	count: number
	activeIndex: number
	onClick?: (index: number) => void
}

export const Pagination = (props: PaginationProps) => {
	const { count, activeIndex, onClick } = props

	const elementsArray = Array(count).fill(null)

	const bulletClasses = (index: number) =>
		clsx(cl.pagination__bullet, {
			[cl.pagination__bullet_active]: index === activeIndex
		})

	return (
		<div className={cl.pagination}>
			<div className={cl.pagination__container}>
				{elementsArray.map((_, index) => (
					<span key={index} className={bulletClasses(index)} onClick={() => onClick?.(index)}>
						{shouldRenderInnerSpan(index, activeIndex) && <span />}
					</span>
				))}
			</div>
		</div>
	)
}
